import { createSlice } from "@reduxjs/toolkit";

// # types
interface ProgressState {
  count: number;
}

// # initial state
const initialState: ProgressState = {
  count: 0,
};

// # slice
const progressSlice = createSlice({
  name: "progress",
  initialState,
  reducers: {
    startProgress(state) {
      state.count += 1;
    },
    stopProgress(state) {
      state.count = Math.max(state.count - 1, 0);
    },
    resetProgress(state) {
      state.count = 0;
    },
  },
});

// # actions
export const { startProgress, stopProgress, resetProgress } =
  progressSlice.actions;

export default progressSlice.reducer;
